import Vue from "vue";
import App from "./App.vue";
// import VirtualCollection from 'vue-virtual-collection'

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import StickyNav from "vue-sticky-nav";
import "./style/index.css";

import router from "./router";

// Vuex Store
import store from "./store/store";

import Sticky from "sticky-js";
var sticky = new Sticky(".sticky");
sticky.update();
var sticky2 = new Sticky(".sticky2");
sticky2.update();
// Vue.use(VirtualCollection)
Vue.use(StickyNav);
// Vue.use(Sticky)
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.config.productionTip = false;

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "zh", //默认语言
  fallbackLocale: 'zh',
  cache: false,
  messages: {
    zh: require("@/lang/zh.js"),
    en: require("@/lang/en.js"),
  },
});
// i18n.setLocaleMessage();

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#app");
